import React, { Component, Fragment } from 'react';

class Schedule extends Component {
  render() {
    let excluded = this.props.excluded || [];
    let weekday = this.props.weekday;

    let skipdays = [
      { text: 'Mon', index: 1 },
      { text: 'Tue', index: 2 },
      { text: 'Wed', index: 3 },
      { text: 'Thu', index: 4 },
      { text: 'Fri', index: 5 },
      { text: 'Sat', index: 6 },
      { text: 'Sun', index: 0 }
    ];

    let weekDays = [
      { text: '5 Days', index: 5 },
      { text: '7 Days', index: 7 },
      { text: '6 Days', index: 6 }
    ];
    
    return (
      <section
        className="step-form-input"
        id="schedule"
      >
        <div className="goal-heading">
          <div className="goal-number">
            03
          </div>
          <h2>
            Which days of the week?
          </h2>
          <span>03</span>
        </div>

        <div className="week-days">
          <div className="option-grid">
            {weekDays.map(
              function(value) {
                let checked =
                  weekday == value.index;

                return (
                  <Fragment key={value.index}>
                    <label
                      className="option-item"
                      htmlFor={
                        'labelweekdays-' +
                        value.index
                      }
                    >
                      <input
                        type="radio"
                        value={value.index}
                        name="weekdays"
                        id={
                          'labelweekdays-' +
                          value.index
                        }
                        checked={checked}
                        onChange={function(e) {
                          let value1 =
                            parseInt(
                              e.target.value,
                              10
                            );

                          let excludedVal = [];
                          let day = 28;

                          if (value1 === 6) {
                            excludedVal = ['0'];
                            day = 24;
                          } else if (
                            value1 === 5
                          ) {
                            excludedVal = [
                              '6',
                              '0'
                            ];
                            day = 20;
                          }

                          this.props.onWeekdayChange(
                            {
                              weekday:
                                value1,
                              excluded:
                                excludedVal,
                              dayCount: day
                            }
                          );
                        }.bind(this)}
                      />

                      <span className="avenir-heavy font-16">
                        {value.text}<span> a Week</span>
                      </span>

                      <div className="checkmark1">
                       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 10.8L3.2 8L2 9.2L6 13.2L14 5.2L12.8 4L6 10.8Z" fill="white"/>
    </svg>
                      </div>
                    </label>
                  </Fragment>
                );
              }.bind(this)
            )}
          </div>

          <div className="days_list">
            <div className="avenir-medium font-16">
              Select
              <br />
              Active Days:
            </div>

            <div className="days">
              {skipdays.map(
                function(value) {
                  let checked =
                    !excluded.includes(
                      String(value.index)
                    );

                  return (
                    <Fragment
                      key={value.index}
                    >
                      <label
                        className="day"
                        htmlFor={
                          'labelskipdays-' +
                          value.index
                        }
                      >
                        <svg width="55" height="59" viewBox="0 0 55 59" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36.2227 0C37.2796 0 38.1367 0.857118 38.1367 1.91406V7.06543H50.1934C52.8438 7.06543 55 9.22167 55 11.8721V55H54.7803C54.1683 56.9513 52.3439 58.3711 50.1934 58.3711H4.80566C2.15527 58.3711 0 56.2149 0 53.5645V11.8721C0 9.22167 2.15527 7.06543 4.80566 7.06543H16.8633V1.91406C16.8633 0.857118 17.7194 0 18.7764 0C19.8333 2.03464e-05 20.6895 0.85713 20.6895 1.91406V7.06543H34.3096V1.91406C34.3096 0.857194 35.1658 0.000123873 36.2227 0ZM4.80566 10.8926C4.26609 10.8926 3.82715 11.3317 3.82715 11.8721V18.2637H51.1738V11.8721C51.1738 11.3317 50.7337 10.8926 50.1934 10.8926H4.80566Z" fill="#3A6659"/>
    </svg><input
                          type="checkbox"
                          value={value.index}
                          name="skipdays"
                          id={
                            'labelskipdays-' +
                            value.index
                          }
                          checked={checked}
                          onChange={function(
                            e
                          ) {
                            this.props.onExcludedChange(
                              e.target.value
                            );
                          }.bind(this)}
                        />

                        <span className="avenir-medium font-16">
                          {value.text}
                        </span>
                      </label>
                    </Fragment>
                  );
                }.bind(this)
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Schedule;
